import { render, staticRenderFns } from "./ManufacturerIndex.vue?vue&type=template&id=5e360d1c&scoped=true&"
import script from "./ManufacturerIndex.vue?vue&type=script&lang=js&"
export * from "./ManufacturerIndex.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerIndex.vue?vue&type=style&index=0&id=5e360d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e360d1c",
  null
  
)

export default component.exports